import { call, put } from "redux-saga/effects";
import * as apis from "../../../network/apis/FlashCards/Questions";
import messages from "../../../assets/locale/messages";
import { showHideSnackbar } from "../../Snackbar/actions";
import {
  deleteSingleFlashCardResponse,
  getAllFlashCardResponse,
  getSingleFlashCardResponse
} from "./actions";
import { ROUTE_PATHS } from "../../../utils/PathsNames";
import History from "../../../routes/History";

export function* AddArrayFlashCardSaga({ payload }) {
  try {
    const response = yield call(apis.addArrayOfFlashCards, payload);

    const failed = response?.data.results?.failed || [];
    console.log("failed", response);

    if (failed.length > 0) {
      // collect all error messages
      const errorMessages = failed
        .map((item) => item.errors.join(", "))
        .join(" | ");

      yield put(
        showHideSnackbar({
          isOpen: true,
          type: "error",
          message: errorMessages
        })
      );
    } else {
      yield put(
        showHideSnackbar({
          isOpen: true,
          type: "success",
          message:
            messages[response.lang].flashcard.addFlashCardSuccess
        })
      );
      yield History.push(ROUTE_PATHS.flashcardQuestions);
    }
  } catch (err) {
    yield put(
      showHideSnackbar({
        isOpen: true,
        type: "error",
        message: "Something went wrong"
      })
    );
    console.error(err);
  }
}

export function* getAllFlashCardSaga({ payload }) {
  try {
    const response = yield call(apis.getAllFlashcards, payload);
    yield put(
      getAllFlashCardResponse({
        list: response.data.flashcards,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"]
        }
      })
    );
  } catch (err) {
    console.error(err);
  }
}

export function* getSingleFlashCardSaga({ payload }) {
  try {
    const response = yield call(apis.getSingleFlashcard, payload);
    yield put(getSingleFlashCardResponse(response.data.flashcard));
  } catch (err) {
    console.error(err);
  }
}
export function* editSingleFlashCardSaga({ payload }) {
  try {
    console.log("payload editSingleFlashCardSaga", payload);
    const response = yield call(apis.editSingleFlashcard, payload);
    yield put(
      showHideSnackbar({
        isOpen: true,
        type: "success",
        message:
          messages[response.lang].flashcard.editFlashCardSuccess
      })
    );
    yield History.push(ROUTE_PATHS.flashcardQuestions);
  } catch (err) {
    console.error(err);
  }
}

export function* deleteSingleFlashCardSaga({ payload }) {
  try {
    console.log("payload deleteSingleFlashCardSaga", payload);

    const response = yield call(apis.deleteSingleFlashcard, payload);
    yield put(
      showHideSnackbar({
        isOpen: true,
        type: "success",
        message:
          messages[response.lang].flashcard.deleteFlashCardSuccess
      })
    );
    yield put(deleteSingleFlashCardResponse(payload.id));
    // yield History.push(ROUTE_PATHS.flashcardQuestions);
  } catch (err) {
    console.error(err);
  }
}
